import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=525d8b12&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=525d8b12&prod&lang=scss&scoped=true"
import style1 from "./CompanySettings.vue?vue&type=style&index=1&id=525d8b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d8b12",
  null
  
)

export default component.exports